import React, { PureComponent } from 'react';

import ShiftAlert from './ShiftAlert';

export default class EarlyClockIn extends PureComponent {
  render() {
    return <ShiftAlert {...this.props} />;
  }
}
